import React, { useCallback, useRef, useEffect, useState } from "react";
import "./index.less";

const defaultTime = 60 * 20;

const useGreet = (isOpen) => {
  const [time, setTime] = useState(defaultTime);
  const [show, setShow] = useState(false);
  const [startClock, setStartClock] = useState(true);
  const timer = useRef();

  const greetVideoRef = useRef();
  useEffect(() => {
    if (!startClock || !isOpen) {
      return;
    }
    timer.current = setInterval(() => {
      setTime((t) => {
        if (t <= 0) {
          clearInterval(timer.current);
          setShow(true);
        }
        return t - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startClock, time, isOpen]);

  useEffect(() => {
    if (show && isOpen) {
      startGreet();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const startGreetTime = () => {
    setStartClock(true);
  };

  const resetGreetTime = () => {
    setShow(false);
    setTime(defaultTime);
    setStartClock(false);
  };

  const startGreet = () => {
    greetVideoRef.current.currentTime = 0;
    greetVideoRef.current.play();
    setStartClock(false);
  };

  const GreetVideo = useCallback(() => {
    return (
      <video
        ref={greetVideoRef}
        style={{ zIndex: show ? 999 : -1, opacity: show ? 1 : 0 }}
        className="greetVideo"
        src="https://kechuangyun-static-1304630716.cos.ap-beijing.myqcloud.com/aiDiaital/greet.mp4"
        onClick={() => {
          setShow(false);
          resetGreetTime();
          startGreetTime();
        }}
        onEnded={() => {
          setShow(false);
          resetGreetTime();
          startGreetTime();
        }}
      />
    );
  }, [show]);

  return {
    GreetVideo,
    startGreet,
    startGreetTime,
    resetGreetTime,
  };
};

export { useGreet };
